"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exhaustiveCheck = exhaustiveCheck;
exports.oneOfOrUndefined = oneOfOrUndefined;
exports.ensureSubsetOfKeys = ensureSubsetOfKeys;
exports.ensureKey = ensureKey;
/** When placed in the 'default' branch of a switch statement, this will throw a compile error if all cases of the switch
 * are not handled. At runtime, nothing will happen. e.g.
 * const errorCode: 400|401|403 = 400;
 * switch (errorCode) {
 *   case 400:
 *     return "BadRequest";
 *   case 401:
 *     return "Unauthorized";
 *   defaut:
 *     exhaustiveCheck(errorCode); // This will be a compile time error. At run time, nothing will happen.
 * }
 */
function exhaustiveCheck(_value) {
    // Do nothing, this function only causes a compile time error
    //
    // If we have cases where an exhaustive check should throw at runtime, we can either add a parameter or
    // create a similar function that takes the message to throw, and returns type 'never'
}
/**
 * Returns the value if it matches one of the provided options, otherwise returns undefined.
 */
function oneOfOrUndefined(value, ...validValues) {
    if (validValues.includes(value)) {
        return value;
    }
    return undefined;
}
/** Checks that the second param has keys that are a subset of the first param
 *    ensureSubsetOfKeys({ a: 0, b: 1, c: 2 }, { a: 0 }); // success
 *    ensureSubsetOfKeys({ a: 0, b: 1, c: 2 }, { a: "string" }); // success
 *    ensureSubsetOfKeys({ a: 0, b: 1, c: 2 }, { a: "string", b: { d: true} }); // success
 *    ensureSubsetOfKeys({}, {}); // success
 *    ensureSubsetOfKeys({ a: 0, b: 1, c: 2 }, { x: 0 }); // fails, x is a new property in second arg
 *    ensureSubsetOfKeys({ a: 0, b: 1, c: 2 }, { a: "string", b: { d: true }, x: { e: false } }); // fails, x is a new property in second arg
 *    ensureSubsetOfKeys({}, { x: 0 }); // fails, x is a new property in second arg
 */
function ensureSubsetOfKeys(_fullObject, subsetObject) {
    // This function does nothing at runtime; it exists purely for type-checking.
    return subsetObject;
}
/** When given an object and a key, causes a compile error if the key is not a valid key for the object, otherwise the key is returned */
function ensureKey(_obj, key) {
    return key;
}
//# sourceMappingURL=types.js.map